import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IWorkbookRevision } from '../types/IWorkbookRevision';

export interface IGetWorkbookVersionsParams extends IGetItemsParams {
}

export interface IGetWorkbookVersionsResult extends IGetItemsResult {
  versions: IWorkbookRevision[];
}

export class GetWorkbookVersionsRequest extends Request<IGetWorkbookVersionsParams, IGetWorkbookVersionsResult> {
  constructor(params: IGetWorkbookVersionsParams) {
    super('getWorkbookVersions', params);
  }
}
